import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Hero from '../components/hero';
import SideBySide from '../components/side-by-side';
// import TeamTile from "../components/team-tile";
// import TeamGrid from "../components/team-grid";
// import IntegrationsGrid from "../components/integrations-grid"
import IntegrationsGrid from '../components/integrations-grid';
import Carousel from '../components/carousel';
import DialogButton from '../components/dialogButton';

const Analytics = () => {
    const data = useStaticQuery(graphql`
        query {
            hero: file(relativePath: { eq: "analytics-hero.jpeg" }) {
                childImageSharp {
                    fluid(maxWidth: 2600, jpegQuality: 80) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            map: file(relativePath: { eq: "map.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            category: file(relativePath: { eq: "category.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            snapshot: file(relativePath: { eq: "snapshot.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            executive: file(relativePath: { eq: "executive-metrics.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            visitor: file(relativePath: { eq: "visitor-metrics.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <Layout>
            <SEO
                title="Dispensary Analytics"
                url="/dispensary-analytics"
                description="Make your data work for you. The hardest part of analyzing your data for insights is knowing what questions to ask. Weave's Analytics Platform is the best in the industry, based on extensive market research and delivered with pre-configured dashboards."
            />
            <Hero
                buttonsList={[
                    <DialogButton analyticsValue={3} key="talk">
                        Learn More
                    </DialogButton>,
                ]}
                copy={[
                    "Make your data work for you. The hardest part of analyzing your data for insights is knowing what questions to ask. Weave's Analytics Platform is the best in the industry, based on extensive market research and delivered with pre-configured dashboards.",
                ]}
                header="Analytics"
                image={data.hero.childImageSharp.fluid}
            />
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy={[
                        'Weave Analytics delivers critical business performance metrics to help your executive team assess overall business performance.',
                        <br key="one"></br>,
                        <br key="two"></br>,
                        'Pre-configured and beautifully designed dashboards identify sales trends, margin, inventory patterns, staff performance, and critical customer demographic information. The strain of exporting data and consolidating custom spreadsheets to understand business performance is gone.',
                    ]}
                    image={data.executive.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="Executive Metrics"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    bulletsList={[
                        'Assess sales and margin performance by state, store, category, brand, salesperson, even day of week and time of day.',
                        'View inventory data (past and present) to measure carrying cost, retail value, and assortment across categories.',
                    ]}
                    copy="These are just some of the ways we can make your data work for you."
                    image={data.visitor.childImageSharp.fluid}
                    imagePosition={'right'}
                    sideHeader="Why Weave Analytics?"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    bulletsList={[
                        'Sign up for a daily snapshot, delivered directly to your mobile device, providing key sales and margin information that keeps your executive team up to date on how the business is performing, each and every day.',
                        'For multi-store, multi-state operators, Weave delivers a consolidated view of all operations data in one place, accessible anywhere and on any device.',
                    ]}
                    copy=""
                    image={data.category.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="...Go On"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    buttonsList={[
                        <DialogButton key="dialogButton">
                            I'm Ready to Get Started
                        </DialogButton>,
                    ]}
                    copy="When you deploy Weave in your business, your overall operating model unequivocally improves. Skeptical? Talk to our customers. They will, across the board, echo this sentiment."
                    image={data.snapshot.childImageSharp.fluid}
                    imagePosition={'right'}
                    sideHeader="The Bottom Line"
                />
            </div>
            <div className="parallax-section parallax-white">
                <IntegrationsGrid
                    header="API Integrations"
                    copy="We understand we can't do it all. By partnering with the best in the industry, we make sure you and your customers have a seamless end to end experience."
                />
            </div>
            <Carousel />
        </Layout>
    );
};

export default Analytics;
